import { render, staticRenderFns } from "./MyCashAdvances.vue?vue&type=template&id=6b0c0607&scoped=true"
import script from "./MyCashAdvances.vue?vue&type=script&lang=js"
export * from "./MyCashAdvances.vue?vue&type=script&lang=js"
import style0 from "./MyCashAdvances.vue?vue&type=style&index=0&id=6b0c0607&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0c0607",
  null
  
)

export default component.exports